export const normalizeUserData = (data: any) => {
  
  const normalized = {
    program: data.program_card,
    user: data.user_data,
    organization: data.organization_data,
    programData: data.program_data,
    support: data.support_data,
    talkjs: data.talkjs,
  };
  
  return normalized;
};

export default normalizeUserData;
